import React from 'react';
import { useHistory } from "react-router-dom";
import { Button } from "../../atoms/RTCC/button";
import { InstitutionDetailModalContainer } from '../../organisms/RTCC/institutionDetailModalContainer';
import './../../../resources/RTCC/css/top/top.css';
import { useStore } from 'react-redux';

export const TopContentBlock = (props) => {

    const {
        setOutsideHoursFlg,
        setMenuTitle
    } = props;

    const store = useStore();
    const history = useHistory();
    const envParam = store.getState().envParam;

    // 予約ボタン押下処理
    const onClickService = () => {
        // ホテル・レストラン予約の場合、営業時間チェック
        if (props.idName === 3 || props.idName === 4) {
            let loginDate = new Date();
            let loginHour = loginDate.getHours().toString();
            let loginMinute = loginDate.getMinutes() < 10 ? "0" + loginDate.getMinutes().toString() : loginDate.getMinutes().toString();
            const loginTime = Number(loginHour + loginMinute);
            const outsideHoursStart = envParam?.open ? Number(envParam.open) : 2400;
            const outsideHoursEnd = envParam?.close ? Number(envParam.close) : 0;
            if (outsideHoursStart <= loginTime && loginTime <= outsideHoursEnd) {
                setOutsideHoursFlg(true);
                setMenuTitle(props.TopContentAlt);
            } else {
                history.push(props.menu);
            }
        } else {
            history.push(props.menu);
        }
    };

    //  ゴルフ一人予約　表示時にコメントアウト外す
    const onClickGolfSolo = () => {
        history.push("/reserve/golf/soloSearch");
    };

    return (
        <div id={props.idName} className={props.isMobilePhone ? "TopContentBlockMobile" : "TopContentBlock"}>
            <div className="TopContentImageWrap">
                <p className="TopImageText">{props.TopImageText}</p>
                <img className="TopContentImage" src={`${props.TopContentImage} `} alt={props.TopContentAlt} />
            </div>
            <div className={props.isMobilePhone ? "TopContentWrapMobile" : "TopContentWrap"}>
                <p className={props.isMobilePhone ? "TopContentTextMobile" : "TopContentText"}>{props.TopContentText}</p>
                <div className="BackButtonSet" style={props.idName === 1 ? {alignItems:"baseline"} :null}>
                    <InstitutionDetailModalContainer
                        popupData={props.popupData}
                        onClickService={onClickService}
                        onClickService2={onClickGolfSolo}　//一人予約ボタン表示時にコメントアウト外す
                        idName={props.idName}
                    />
                    {/* ゴルフ一人予約　表示時に以下Buttonをコメントアウトする */}
                    {/* <Button
                        buttonText="予約する"
                        className="ReservationButton"
                        buttonClassName="ReservationButtonText"
                        onClick={onClickService}
                    /> */}
                    {/* ゴルフ一人予約　表示時に以下Buttonをコメントアウト外す */}
                    {props.idName === 1 ?
                        <div>
                            <Button buttonText="組予約" className="ReservationButton" buttonClassName="ReservationButtonText"  onClick={onClickService} />
                            <Button buttonText="一人予約" className="GolfSoloReservationButton" buttonClassName="ReservationButtonText"  onClick={onClickGolfSolo} />
                        </div>
                        :
                        <Button
                            buttonText="予約する"
                            className="ReservationButton"
                            buttonClassName="ReservationButtonText"
                            onClick={onClickService}
                        />
                    }
                    {/* ここまで */}
                </div>
            </div>
        </div>
    );
}